import './menu.css';import '../dropdown.shared.css';import '../../styles/components/ellipsis.css';import '../../styles/components/state.css';import '../../styles/components/resets.css';/* empty css                                                   */
/* empty css                                                  */
/* empty css                                                     */
/* empty css                                       */
/* empty css                           */
//#region src/components/menu/menu.css.ts
var menuVars = { popupWidth: "var(--_1gapj780)" };
var menuPopup = "_1gapj781 sf2fpj3 sf2fpj2 sf2fpj1 _14zs3h0";
var menuItem = "_1gapj782 sf2fpja _14zs3h0 _14zs3h1 _16pesku0";
//#endregion
export { menuItem, menuPopup, menuVars };
